/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ApiAppExceptionTestBrokerExceptionGet400Response } from '../model/api-app-exception-test-broker-exception-get400-response.model';
// @ts-ignore
import { ProductServoPipelineResultDto } from '../model/product-servo-pipeline-result-dto.model';
// @ts-ignore
import { PublicServoAntragSignInfoDto } from '../model/public-servo-antrag-sign-info-dto.model';
// @ts-ignore
import { PublicServoAntragSignSubmitDto } from '../model/public-servo-antrag-sign-submit-dto.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class PublicServoAntragSignApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/public-servo-antrag-sign/contract/{servoContractId}/antrag-preview
     * @param servoContractId 
     * @param oneTimeAccessToken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoAntragSignContractServoContractIdAntragPreviewGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public apiPublicServoAntragSignContractServoContractIdAntragPreviewGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public apiPublicServoAntragSignContractServoContractIdAntragPreviewGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public apiPublicServoAntragSignContractServoContractIdAntragPreviewGet(servoContractId: string, oneTimeAccessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servoContractId === null || servoContractId === undefined) {
            throw new Error('Required parameter servoContractId was null or undefined when calling apiPublicServoAntragSignContractServoContractIdAntragPreviewGet.');
        }
        if (oneTimeAccessToken === null || oneTimeAccessToken === undefined) {
            throw new Error('Required parameter oneTimeAccessToken was null or undefined when calling apiPublicServoAntragSignContractServoContractIdAntragPreviewGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>oneTimeAccessToken, 'oneTimeAccessToken');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/public-servo-antrag-sign/contract/${this.configuration.encodeParam({name: "servoContractId", value: servoContractId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/antrag-preview`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint post /api/public-servo-antrag-sign/contract/{servoContractId}
     * @param servoContractId 
     * @param publicServoAntragSignSubmitDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoAntragSignContractServoContractIdPost(servoContractId: string, publicServoAntragSignSubmitDto?: PublicServoAntragSignSubmitDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ProductServoPipelineResultDto>;
    public apiPublicServoAntragSignContractServoContractIdPost(servoContractId: string, publicServoAntragSignSubmitDto?: PublicServoAntragSignSubmitDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ProductServoPipelineResultDto>>;
    public apiPublicServoAntragSignContractServoContractIdPost(servoContractId: string, publicServoAntragSignSubmitDto?: PublicServoAntragSignSubmitDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ProductServoPipelineResultDto>>;
    public apiPublicServoAntragSignContractServoContractIdPost(servoContractId: string, publicServoAntragSignSubmitDto?: PublicServoAntragSignSubmitDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servoContractId === null || servoContractId === undefined) {
            throw new Error('Required parameter servoContractId was null or undefined when calling apiPublicServoAntragSignContractServoContractIdPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-antrag-sign/contract/${this.configuration.encodeParam({name: "servoContractId", value: servoContractId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ProductServoPipelineResultDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: publicServoAntragSignSubmitDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/public-servo-antrag-sign/contract/{servoContractId}/signature-info
     * @param servoContractId 
     * @param oneTimeAccessToken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPublicServoAntragSignContractServoContractIdSignatureInfoGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PublicServoAntragSignInfoDto>;
    public apiPublicServoAntragSignContractServoContractIdSignatureInfoGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PublicServoAntragSignInfoDto>>;
    public apiPublicServoAntragSignContractServoContractIdSignatureInfoGet(servoContractId: string, oneTimeAccessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PublicServoAntragSignInfoDto>>;
    public apiPublicServoAntragSignContractServoContractIdSignatureInfoGet(servoContractId: string, oneTimeAccessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (servoContractId === null || servoContractId === undefined) {
            throw new Error('Required parameter servoContractId was null or undefined when calling apiPublicServoAntragSignContractServoContractIdSignatureInfoGet.');
        }
        if (oneTimeAccessToken === null || oneTimeAccessToken === undefined) {
            throw new Error('Required parameter oneTimeAccessToken was null or undefined when calling apiPublicServoAntragSignContractServoContractIdSignatureInfoGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>oneTimeAccessToken, 'oneTimeAccessToken');

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/public-servo-antrag-sign/contract/${this.configuration.encodeParam({name: "servoContractId", value: servoContractId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/signature-info`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PublicServoAntragSignInfoDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
